import { DeleteOutlined } from '@ant-design/icons';
import { Popconfirm, Row, Col } from 'antd';
import { ColumnsType } from 'antd/es/table';
import config from 'config';
import { format } from 'date-fns';
import { InvitationOutput, InvitationListSort } from 'gql/types';
import { Button } from 'modules/common/components';
import { ISortOption } from 'modules/common/interfaces';
import { createSortOrderFactory } from 'modules/common/utils/sort/createSortOrderFactory';
import { getTranslation } from 'utils/getTranslation';

const t = getTranslation('admin.InvitationsPage');

type ColumnsProps = {
  deleteHandler?: (userId: string) => void;
  onClickEditIcon?: (userId: string) => void;
  canDelete: boolean;
  canUpdateUserInfo: boolean;
  currentUserEmail?: string;
  showSorterTooltip?: boolean;
  sort?: ISortOption<InvitationListSort>;
};

export const getColumns = ({
  deleteHandler,
  canDelete,
  showSorterTooltip,
  currentUserEmail,
  sort,
}: ColumnsProps): ColumnsType<InvitationOutput> => {
  const getDefaultSort = createSortOrderFactory<InvitationListSort>(sort);
  return [
    {
      title: t('firstName'),
      key: InvitationListSort.FirstName,
      dataIndex: 'firstName',
      sorter: true,
      showSorterTooltip,
      align: 'center',
      sortOrder: getDefaultSort(InvitationListSort.FirstName),
    },
    {
      title: t('lastName'),
      key: InvitationListSort.LastName,
      dataIndex: 'lastName',
      sorter: true,
      showSorterTooltip,
      align: 'center',
      sortOrder: getDefaultSort(InvitationListSort.LastName),
    },
    {
      title: t('email'),
      key: 'email',
      dataIndex: 'email',
      align: 'center',
    },
    {
      title: t('role'),
      key: 'role',
      dataIndex: 'role',
      align: 'center',
    },
    {
      title: t('date'),
      key: InvitationListSort.CreatedAt,
      dataIndex: 'createdAt',
      sorter: true,
      sortOrder: getDefaultSort(InvitationListSort.CreatedAt),
      render: (date: string) =>
        format(new Date(date), config.DATE_FORMATS.DATE),
      align: 'center',
    },
    {
      key: 'actions',
      align: 'center',
      render: (record: InvitationOutput) => {
        const isMe = currentUserEmail === record.email;
        if (isMe) {
          return t('me');
        }

        return (
          <Row justify="space-around">
            {canDelete && (
              <Col>
                <Popconfirm
                  title={t('areYouSureYouWantToDeleteInvitation')}
                  onConfirm={() => deleteHandler?.(record.id)}
                  okText={t('yes')}
                  cancelText={t('no')}
                >
                  <Button type="text" icon={<DeleteOutlined />} />
                </Popconfirm>
              </Col>
            )}
          </Row>
        );
      },
    },
  ];
};
